import { Box, Card, Center, Stack, Text, Title } from "@mantine/core";
import { LinkPateronButton } from "./link-patreon-button";
import { BecomePatreonButton } from "./become-patreon-button";

export function LinkPatreonCard() {
  return (
    <Card withBorder maw={500}>
      <Center>
        <Title mb="md">
          Link your{" "}
          <Text inherit span c="orange">
            Patreon
          </Text>{" "}
          account
        </Title>
      </Center>
      <Text>
        Currently this site is <em>only available</em> to <b>patrons</b>. Once
        you signup you will gain{" "}
        <Text span c="pink">
          early access
        </Text>{" "}
        to new features while also being able to provide{" "}
        <Text span c="pink">
          direct feedback
        </Text>{" "}
        to the team.
      </Text>
      <Box p="xl">
        <Stack gap="md">
          <Title size="h3">Step 1</Title>
          <BecomePatreonButton />
          <Title size="h3">Step 2</Title>
          {<LinkPateronButton />}
        </Stack>
      </Box>
    </Card>
  );
}
